/* Viral Supply — cart helpers */
(function () {
  /* Frequently Bought Together: submit only checked items */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.vs-fbt-form');
    if (!form) return;
    e.preventDefault();
    form.querySelectorAll('[data-vs-gen]').forEach(function (n) { n.remove(); });
    var ids = [];
    var main = form.getAttribute('data-main-id');
    if (main) ids.push(main);
    form.querySelectorAll('.vs-fbt__check:checked').forEach(function (c) { if (c.value) ids.push(c.value); });
    ids.forEach(function (id, i) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'items[' + i + '][id]'; inp.value = id; inp.setAttribute('data-vs-gen', '1');
      form.appendChild(inp);
    });
    form.submit();
  });

  /* Relabel checkout button -> "Secure Checkout" with a lock icon */
  function fixCheckout() {
    document.querySelectorAll('.cart__checkout-button .button-text').forEach(function (el) {
      if (el.dataset.vsSecured) return;
      el.dataset.vsSecured = '1';
      el.innerHTML = '<span class="material-symbols-outlined" style="font-size:18px;vertical-align:-4px;margin-right:6px;">lock</span>Secure Checkout';
    });
  }

  /* Sticky add-to-cart: reflect the selected pack (qty, struck old + new price) */
  var PACK = {
    1: { now: '$49.99', was: '$79.99',  title: 'Galaxy Projector' },
    2: { now: '$79.99', was: '$159.98', title: '2 × Galaxy Projector' },
    3: { now: '$109.99', was: '$239.97', title: '3 × Galaxy Projector' }
  };
  function syncSticky(q) {
    var p = PACK[q]; if (!p) return;
    document.querySelectorAll('.sticky-add-to-cart__title').forEach(function (el) { el.textContent = p.title; });
    document.querySelectorAll('.sticky-add-to-cart .price-item--sale').forEach(function (el) { el.textContent = p.now; });
    document.querySelectorAll('.sticky-add-to-cart .price-item--regular').forEach(function (el) { el.textContent = p.was; });
  }
  window.addEventListener('vs:pack', function (e) { syncSticky(e.detail && e.detail.qty); });

  /* Re-render the cart drawer inner from a Section Rendering API response */
  function swapDrawerInner(html) {
    var curInner = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (!curInner || !html) { location.reload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newInner = doc.querySelector('.cart-drawer__inner');
    if (!newInner) { location.reload(); return; }
    curInner.innerHTML = newInner.innerHTML;
    curInner.className = newInner.className;
    setTimeout(function () { fixCheckout(); }, 30);
  }
  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (data) {
      var sec = data && data.sections && data.sections['cart-drawer-section'];
      if (sec) { swapDrawerInner(sec); } else { location.reload(); }
    }).catch(function () { location.reload(); });
  }

  /* Custom cart line: quantity +/- and remove */
  document.addEventListener('click', function (e) {
    var qbtn = e.target.closest && e.target.closest('.vs-line__qty button');
    var rm = e.target.closest && e.target.closest('.vs-line__rm');
    if (!qbtn && !rm) return;
    e.preventDefault();
    var el = qbtn || rm;
    if (el.dataset.busy) return;
    el.dataset.busy = '1';
    var key = el.getAttribute('data-key');
    var qty = rm ? 0 : parseInt(el.getAttribute('data-q'), 10);
    cartPost('/cart/change.js', { id: key, quantity: qty, sections: 'cart-drawer-section' });
  });

  /* Shipping-protection toggle */
  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('.vs-prot__check');
    if (!c) return;
    c.disabled = true;
    var vid = c.getAttribute('data-vid');
    if (c.checked) {
      cartPost('/cart/add.js', { items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer-section' });
    } else {
      cartPost('/cart/change.js', { id: vid, quantity: 0, sections: 'cart-drawer-section' });
    }
  });

  function watch(node) {
    if (!node) return;
    try { new MutationObserver(function () { setTimeout(fixCheckout, 30); }).observe(node, { childList: true, subtree: true }); } catch (e) {}
  }
  function boot() {
    fixCheckout();
    watch(document.getElementById('cart-drawer'));
    var sel = document.querySelector('.vs-qp__opt.is-selected');
    if (sel) setTimeout(function () { syncSticky(parseInt(sel.getAttribute('data-qty'), 10)); }, 500);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();